import React from "react";

import { ComponentTemplateDialog_rootRef$key } from "./__generated__/ComponentTemplateDialog_rootRef.graphql";

export const ComponentTemplatesContext =
  React.createContext<ComponentTemplateDialog_rootRef$key>(null);
